import React, { useState, useCallback } from 'react';
import Popover from '@material-ui/core/Popover';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import { Select } from '@this/src/components/shared/ui/inputs/select';
import { useAITTheme } from '@this/shared/ui/theme';
import { OrderItemStatus, OrderItemStatusAvailable2 } from '@this/src/domain/order_item/order_item_status';

export type JobType = 'reserve' | 'change' | 'cancel';

const JOB_TYPE_OPTIONS: { value: JobType; label: string }[] = [
  { value: 'reserve', label: '新規' },
  { value: 'change', label: '変更' },
  { value: 'cancel', label: 'キャンセル' }
];

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onConfirm: (jobType: JobType, targetStatus: number) => void;
}

const RestartSequencePopover: React.FC<Props> = ({ anchorEl, onClose, onConfirm }) => {
  const { theme } = useAITTheme();
  const [selectedJobType, setSelectedJobType] = useState<JobType>('reserve');
  const [selectedStatus, setSelectedStatus] = useState<number>(OrderItemStatusAvailable2[0]);

  const handleJobTypeChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedJobType(e.target.value as JobType);
  }, []);

  const handleStatusChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedStatus(Number(e.target.value));
  }, []);

  const handleConfirm = useCallback(() => {
    onConfirm(selectedJobType, selectedStatus);
  }, [selectedJobType, selectedStatus, onConfirm]);

  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <div style={{ padding: '16px', minWidth: '280px' }}>
        <div style={{ marginBottom: '16px' }}>
          <div
            style={{
              fontSize: '0.875rem',
              color: theme.grayTextColor,
              marginBottom: '4px'
            }}
          >
            ジョブタイプ
          </div>
          <Select value={selectedJobType} onChange={handleJobTypeChange} size="small" style={{ width: '100%' }}>
            {JOB_TYPE_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
        <div style={{ marginBottom: '16px' }}>
          <div
            style={{
              fontSize: '0.875rem',
              color: theme.grayTextColor,
              marginBottom: '4px'
            }}
          >
            ステータス
          </div>
          <Select value={selectedStatus} onChange={handleStatusChange} size="small" style={{ width: '100%' }}>
            {OrderItemStatusAvailable2.map(status => (
              <option key={status} value={status}>
                {OrderItemStatus[status]}
              </option>
            ))}
          </Select>
        </div>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <Button color="sub" size="small" onClick={onClose}>
            キャンセル
          </Button>
          <Button color="primary" size="small" onClick={handleConfirm}>
            再発火
          </Button>
        </div>
      </div>
    </Popover>
  );
};

export default RestartSequencePopover;
